var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"to":"tooltips"}},[_c('tooltip',{attrs:{"pointer":true,"width":'auto',"delay":800}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }